import React, {useState} from 'react'
//import MedicationSummary from './MedicationSummary';
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationType({prevStep, nextStep}) {
  //const [type, setType] = useState([]);
  //console.log('MedicationType', medsCreateState);

    function selectType(n) {
      //console.log('selectType', n);
      // reset the schedule 
      medsCreateState.type = n.code;
      nextStep(createMedsStep.form);
    }

    const typeList = [
        { 'descr': 'Prescription', 'code': 'P' },
        { 'descr': 'Supplement', 'code': 'S' },
        { 'descr': 'Over the Counter', 'code': 'C' },
        { 'descr': 'Other', 'code': 'O' },
    ];

    return (
      <div className='flex flex-col'>
        <div className='medBody text-center'>
          <b>What type</b> of medication is this?
        </div>
        <div className='medList'>
          <ul>
            {typeList.map((n,ix) => {
              const li = n.code === medsCreateState.type ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
              //console.log('li', n.code, medsCreateState.type, li);
              return (
                <li 
                  key={ix} 
                  className={li}
                  onClick={()=>selectType(n)} 
                  id={n.code}>
                    {n.descr}
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
      );
    }
